<template>
    <div class="">
        <div class="ml-8 pb-4 text-2xl leading-6 font-medium text-gray-900 pb-6 flex-grow">Loading...</div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['user'])
    },
    mounted: function() {
        const perms = this.user?.permissions

        if (perms?.indexOf('admin') != -1) {
            this.$router.push('/dashboard')
        }
        else if (perms?.indexOf('dist') != -1) {
            this.$router.push('/co/distribution')
        }
        else if (perms?.indexOf('co') != -1) {
            this.$router.push('/co')
        }
        else if (perms?.indexOf('bdm') != -1) {
            this.$router.push('/bdm')
        }
    }   
}
</script>